//@flow
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { FlexRow, Spacer } from 'styles/Layout';
import SearchFilter from '../searchFilter';
import { media } from 'styles/Mixins';
import HomieContext from 'HomieContext';
import AuthenticationAction from 'actions/AuthenticationAction';
import swal from '@sweetalert/with-react';
import AppStore from 'stores/AppStore';
import { HeaderIcons } from 'utils/ExportCommon';
import Menu from '../menu/index';

const Wrapper = styled(FlexRow)`
  position: sticky;
  top: 0;
  width: 100%;
  height: 85px;
  background-color: #f9f9f9;
  z-index: 1;
`;

const Container = styled(FlexRow)`
  padding: 0 15px;
  ${media.md`
    width: 100%;
    padding: 0 30px;
    margin: auto;
  `}
`;

const ImageContainer = styled(FlexRow)`
  margin-right: 27px;
`;
const Logo = styled(HeaderIcons.LogoSVG)`
  height: 43px;
  width: 88px;
`;

const LeftTitle = styled.h1`
  height: 44px;
	width: 106px;
	color: #4F5EA3;
	font-size: 18px;
	font-weight: bold;
	line-height: 22px;
}
`;

type PropsType = {
  onChangeSearch: string => void,
  isSearchVisible?: Boolean,
  searchValue: string,
  urlToRedirect: string,
  pathImageLogo: string,
  heading: string,
  location: any,
  history: any,
  match: {
    params: {
      reManagementCompanyId: string,
      reset_password_token: string
    }
  }
};

class Header extends PureComponent<PropsType> {
  static defaultProps = {
    isSearchVisible: true
  };

  componentWillMount() {
    AppStore.addChangeListener(this.actionAfterLogout);
  }

  componentWillUnMount() {
    AppStore.removeChangeListener(this.actionAfterLogout);
  }

  actionAfterLogout = () => {
    const { authenticated } = this.context.currentUser;
    if (!authenticated) this.props.history.push(this.props.urlToRedirect);
  };

  onLogout = () => {
    AuthenticationAction.logout(response => {
      if (response && response.csrf) {
        swal({
          className: 'logout',
          icon: '',
          title: 'Has salido del sistema',
          timer: 5000,
          button: {
            text: 'OK',
            value: true,
            visible: true,
            closeModal: true
          }
        });
      } else {
        location.reload();
      }
    });
  };

  renderSearchFilter = () => {
    const { isSearchVisible, onChangeSearch, searchValue } = this.props;
    if (!isSearchVisible) return null;
    return (
      <SearchFilter
        placeholder=""
        name="filter"
        value={searchValue}
        onChangeFilter={onChangeSearch}
      />
    );
  };

  render() {
    return (
      <Wrapper alignItems="center">
        <Container alignItems="center">
          <LeftTitle>Dashboard Aplicaciones</LeftTitle>
          <Spacer />
          {this.renderSearchFilter()}
          <Menu />
          <ImageContainer justifyContent="center">
            <Logo />
          </ImageContainer>
        </Container>
      </Wrapper>
    );
  }
}

export default withRouter(Header);
Header.contextType = HomieContext;
